import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactModal from 'react-modal';
import { get } from 'lodash'
import { Link, NavLink } from "react-router-dom";
import * as MDICONS from '@material-ui/icons';
import { archiveFloorFromProject, openArchiveFloorFromProjectModal } from '../../../../store/actions/floorActions';
import { setCurrentSnagDetailWithFloorMeta} from '../../../../store/actions/projectActions';
import * as ROUTES from '../../../../constants/routes';
class AddSegmentsAll extends Component {
    constructor(props) {
        super()

        this.state = {
            projectSegmentNameForSearch: "",
            showAddConfirmModal: false,
            toBeChangedEmployeeMapJson: null,
            changerEmployeeMapJson: null,
            showFloorDeleteModal: false,
        }
    }

    /// README: TO BE SEARCH ENTRY
    handleSearch = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    chooseFloor = (snagDetail, floorid, floorMap) => {
        const flooridMap = { floorid: floorid };
        const floorMeta = { ...floorMap, ...flooridMap };
        this.props.setCurrentSnagDetailWithFloorMeta(snagDetail, floorMeta);
    }

    /// README: SEARCH STRING VALIDITY CHECK
    //      (return true if "" and " " is not entered as first character)

    /// README: FILTERS THE accessMap BY SEARCH STRING
    filterBySearch = (s) => {
        const { projectSegmentNameForSearch } = this.state;
        if (projectSegmentNameForSearch === "") {
            console.log('inside')
            return true;
        }
        else {
            console.log('outside')
            var sname = `${s.name}`;
            return sname.toLowerCase().startsWith(projectSegmentNameForSearch.toLowerCase());
        }

    }

    /// README: MODAL CONTROLLING
    // handleOpenModal = (num, changerEmployeeMapJson, toBeChangedEmployeeMapJson) => {
    //     switch (num) {
    //         case 0: {
    //             this.setState({ showAddConfirmModal: true, changerEmployeeMapJson, toBeChangedEmployeeMapJson, });
    //             this.props.openCompanyMemberModal();
    //             break;
    //         }
    //         default: {
    //             this.setState({ showAddConfirmModal: false });
    //             this.props.openCompanyMemberModal();
    //             break;
    //         }
    //     }
    // }

    // handleCloseModal = (num) => {
    //     switch (num) {
    //         case 0: {
    //             this.setState({ showAddConfirmModal: false });
    //             break;
    //         }
    //         default: {
    //             this.setState({ showAddConfirmModal: false });
    //             break;
    //         }
    //     }
    // }

    // componentDidMount() {
    //     this.setState({
    //         projectSegmentNameForSearch: this.props.projectSegmentNameForSearch,
    //     });
    // }

    /// README: MODAL CONTROLLING
    handleOpenSegmentModal = () => {
        this.setState({ showFloorDeleteModal: true, },
            () => this.props.openArchiveFloorFromProjectModal()
        );
    }

    handleCloseSegmentModal = () => {
        this.setState({ showFloorDeleteModal: false });
    }

      /// README: Compare to sort
      compare(a, b) {
        if ('dateCreated' in a && 'dateCreated' in b) {
            if (a.dateCreated && b.dateCreated) {
                if (a.dateCreated.seconds < b.dateCreated.seconds) {
                    return -1;
                }
                if (a.dateCreated.seconds > b.dateCreated.seconds) {
                    return 1;
                }
            }
        }
        return 0;
    }
    render() {
        const { userData, companyData, modalTitleStyle, modalStyles, modalWidthMedium, alu, snagDetail, project, modalInfoTextStyle, commonLabels, floor } = this.props;
        const { uid, employeeid } = userData;
        const { isFloorCreated, fapiMessage, showFapiLoader, fapiIsDoneAndSent } = floor;
        const { assetParts, assetPart, uassetParts, uassetPart, defectMarkers, drawing, drawings, aloneAssetPart } = commonLabels;
        const { isMemberAdded } = project;
        var ueid = uid + employeeid;
        const { uploadNewMapAccess } = alu;
        var accessLevel = snagDetail.accessMap ? ueid in snagDetail.accessMap ? snagDetail.accessMap[ueid]['access'] : alu.invalid : alu.invalid;
        const floorList = Object.values(snagDetail.floorsMap) ?? [];
        var deleteButton = floorList.length === 0 ? <React.Fragment /> : uploadNewMapAccess[accessLevel] ? (<button className="btn btn-flat btn-sm border-dark" style={{ borderRadius: '10px' }} onClick={() => { this.handleOpenSegmentModal() }}><MDICONS.Delete /></button>) : (<React.Fragment></React.Fragment>);
        return (
            <React.Fragment>
                <div className="dynamicModalContainer">
                    <div className="dynamicModalSm">
                        <h5 style={modalTitleStyle}>All {uassetParts}</h5>
                        <p style={modalInfoTextStyle}>Open or create {assetParts}. A {assetPart} can be a floor, room, car's interior, or etc.</p>
                        <input type="text" className="form-control" id="projectSegmentNameForSearch" placeholder="Search for a project segment" onChange={this.handleSearch} />
                        <div style={{ maxHeight: '300px', overflow: 'auto', marginTop: '10px' }}>
                            {snagDetail ? 'floorsMap' in snagDetail ? Object.keys(snagDetail.floorsMap).length !== 0 ? Object.values(snagDetail.floorsMap).sort(this.compare).filter(this.filterBySearch).map((val, i) => {
                                return (
                                    <div key={i}>
                                        <li className="card p-2 m-2" style={{ borderRadius: '10px' }}>
                                            <div className="d-flex" >
                                                <div className="p-2 flex-fill" style={{ fontWeight: "bold" }}>{val.name}
                                                    <br />
                                                </div>
                                                <div className="p-2 flex-fill">
                                                    <Link type="button" className="btn btn-outline-dark btn-sm float-right text-decoration-none" role="button" aria-pressed="true" to={{ pathname: `${ROUTES.IND_PROJECT_FLOOR_MAP_EDITOR}` }} onClick={() => this.chooseFloor(snagDetail, val.floorid, val)} style={{ color: "black", fontWeight: "bold", textDecoration: "underline", borderRadius: '10px' }}>
                                                        Open
                                                    </Link>

                                                </div>
                                                <div className="p-2">
                                                    {deleteButton}
                                                </div>

                                            </div>
                                        </li>


                                        <ReactModal
                                            style={modalStyles}
                                            isOpen={this.state.showFloorDeleteModal && !fapiIsDoneAndSent === true}
                                            onRequestClose={() => { this.handleCloseSegmentModal() }}
                                            contentLabel="Delete Project"
                                            ariaHideApp={false}
                                        >
                                            <button className="close" onClick={() => { this.handleCloseSegmentModal() }}>
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            <div className="dynamicModalContainer">
                                                <div className="dynamicModalSm">
                                                    <React.Fragment>
                                                        <p style={modalTitleStyle}>Confirm delete this {assetPart}?</p>
                                                        <p style={modalTitleStyle}>Warning:</p>
                                                        <p style={modalInfoTextStyle}>Please you must note that this will permenantly delete this {assetParts}.</p>
                                                        <br />

                                                        {!showFapiLoader ? <div className="btn btn-danger btn-sm" style={{ float: "right", borderRadius: '7px' }} onClick={() => this.props.archiveFloorFromProject(userData, snagDetail, val)} >Confirm</div> : <button className="btn btn-danger btn-sm" style={{ float: "right", borderRadius: '7px' }} type="button" disabled>
                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                            &nbsp; Deleting the {assetPart}...
                                                        </button>}
                                                    </React.Fragment>
                                                </div>
                                            </div>
                                        </ReactModal>





                                    </div>
                                )
                            }) : `No ${drawings} found` : `No ${drawings} found` : `No ${drawings} found`}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,

        // styles
        modalWidthMedium: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        modalStyles: state.appControl.modalStyles,
        commonLabels: state.commons,
        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        companyData: state.firestore.data.Company,
        floor: state.floor,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentSnagDetailWithFloorMeta: (snagDetail, floorMeta) => dispatch(setCurrentSnagDetailWithFloorMeta(snagDetail, floorMeta)),
        openArchiveFloorFromProjectModal: () => dispatch(openArchiveFloorFromProjectModal()),
        archiveFloorFromProject: (userModelJson, projectModelJson, floorMapJson) => dispatch(archiveFloorFromProject(userModelJson, projectModelJson, floorMapJson)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddSegmentsAll)
